import { classesConstants as classes } from "../../../constants/classes";

const initialState = {
  loading: true,
  etudiants: [],
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case classes.GET_ETUDIANTS:
      return {
        ...state,
        loading: false,
        etudiants: payload,
      };
    default:
      return state;
  }
}
